import useClassNames from '@medflex/hooks/useClassNames';
import isPrimaryClickEvent from '@medflex/utils/isPrimaryClickEvent';
import PropTypes from 'prop-types';
import React from 'react';
import PopupMenuContext from './PopupMenuContext';

const PopupMenuItem = ({ onClick, className, children, ...props }) => {
  const { isVisible, setIsVisible } = React.useContext(PopupMenuContext);
  const cn = useClassNames(() => ['block', className], [className]);
  return (
    <li className={cn} {...props}>
      <button
        type="button"
        className="flex items-center w-full text-left px-6 py-4 font-semibold outline-none text-slate-600 hover:text-slate-900 bg-white hover:bg-slate-50 focus:outline-none"
        onClick={event => {
          if (isPrimaryClickEvent(event)) {
            onClick(event);
            if (!event.defaultPrevented) setIsVisible(!isVisible);
          }
        }}
      >
        {children}
      </button>
    </li>
  );
};

PopupMenuItem.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

PopupMenuItem.defaultProps = {
  onClick: () => {},
};

export default PopupMenuItem;
